/* eslint-disable */
import { handleApiRequest } from 'Utils/handleApiRequest';

// Template actions
export const SET_PDF_FORM_TEMPLATES = 'SET_PDF_FORM_TEMPLATES';
export const SET_PDF_FORM_TEMPLATE = 'SET_PDF_FORM_TEMPLATE';
export const SET_PDF_FORM_FIELDS = 'SET_PDF_FORM_FIELDS';
export const FETCHING_PDF_FORM_TEMPLATES = 'FETCHING_PDF_FORM_TEMPLATES';
export const PDF_FORM_TEMPLATE_CREATED = 'PDF_FORM_TEMPLATE_CREATED';
export const PDF_FORM_TEMPLATE_DELETED = 'PDF_FORM_TEMPLATE_DELETED';
export const PDF_FORM_FIELDS_SAVED = 'PDF_FORM_FIELDS_SAVED';

// Submission actions
export const SET_PDF_FORM_SUBMISSIONS = 'SET_PDF_FORM_SUBMISSIONS';
export const SET_PDF_FORM_SUBMISSION = 'SET_PDF_FORM_SUBMISSION';
export const PDF_FORM_SUBMISSION_CREATED = 'PDF_FORM_SUBMISSION_CREATED';
export const PDF_FORM_SUBMISSION_EMAILED = 'PDF_FORM_SUBMISSION_EMAILED';
export const PDF_FORM_SUBMISSION_DELETED = 'PDF_FORM_SUBMISSION_DELETED';

interface ActionTypes {
  SET_PDF_FORM_TEMPLATES: object;
  SET_PDF_FORM_TEMPLATE: object;
  SET_PDF_FORM_FIELDS: object;
  FETCHING_PDF_FORM_TEMPLATES: boolean;
  PDF_FORM_TEMPLATE_CREATED: boolean;
  PDF_FORM_TEMPLATE_DELETED: boolean;
  PDF_FORM_FIELDS_SAVED: boolean;
  SET_PDF_FORM_SUBMISSIONS: object;
  SET_PDF_FORM_SUBMISSION: object;
  PDF_FORM_SUBMISSION_CREATED: boolean;
  PDF_FORM_SUBMISSION_EMAILED: boolean;
  PDF_FORM_SUBMISSION_DELETED: boolean;
}

interface MessageAction {
  type: keyof ActionTypes;
  payload: any;
}

export type pdfFormTemplatesActionTypes = MessageAction;

/*
 * NON-API THUNKS
 */

export const setFetchingPdfFormTemplates = (value: boolean) => (dispatch) => {
  dispatch({ type: FETCHING_PDF_FORM_TEMPLATES, payload: value });
};

export const setTemplateCreated = (payload: boolean) => (dispatch) => {
  dispatch({ type: PDF_FORM_TEMPLATE_CREATED, payload });
};

export const setTemplateDeleted = (payload: boolean) => (dispatch) => {
  dispatch({ type: PDF_FORM_TEMPLATE_DELETED, payload });
};

export const setFieldsSaved = (payload: boolean) => (dispatch) => {
  dispatch({ type: PDF_FORM_FIELDS_SAVED, payload });
};

export const setSubmissionCreated = (payload: boolean) => (dispatch) => {
  dispatch({ type: PDF_FORM_SUBMISSION_CREATED, payload });
};

export const setSubmissionEmailed = (payload: boolean) => (dispatch) => {
  dispatch({ type: PDF_FORM_SUBMISSION_EMAILED, payload });
};

export const setSubmissionDeleted = (payload: boolean) => (dispatch) => {
  dispatch({ type: PDF_FORM_SUBMISSION_DELETED, payload });
};

/*
 * TEMPLATE API THUNKS
 */

export const listPdfFormTemplates =
  (companyId: string) =>
  async (dispatch: any, _getState = null, utils: any) => {
    dispatch({ type: FETCHING_PDF_FORM_TEMPLATES, payload: true });

    const response = await handleApiRequest(
      dispatch,
      utils.Api.get(`/companies/${companyId}/pdf-form-templates`)
    );

    if (response?.data) {
      dispatch({ type: SET_PDF_FORM_TEMPLATES, payload: response });
    }

    dispatch({ type: FETCHING_PDF_FORM_TEMPLATES, payload: false });
  };

export const getPdfFormTemplate =
  (templateId: string) =>
  async (dispatch: any, _getState = null, utils: any) => {
    dispatch({ type: FETCHING_PDF_FORM_TEMPLATES, payload: true });
    // Clear stale template/fields immediately so the editor doesn't render old fields on the new PDF
    dispatch({ type: SET_PDF_FORM_TEMPLATE, payload: undefined });
    dispatch({ type: SET_PDF_FORM_FIELDS, payload: [] });

    const response = await handleApiRequest(
      dispatch,
      utils.Api.get(`/pdf-form-templates/${templateId}`)
    );

    if (response?.data) {
      dispatch({ type: SET_PDF_FORM_TEMPLATE, payload: response.data });
      if (response.data.fields) {
        dispatch({ type: SET_PDF_FORM_FIELDS, payload: response.data.fields });
      }
    }

    dispatch({ type: FETCHING_PDF_FORM_TEMPLATES, payload: false });
  };

export const createPdfFormTemplate =
  (formData: FormData) =>
  async (dispatch: any, _getState = null, utils: any) => {
    const response = await handleApiRequest(
      dispatch,
      utils.Api.post('/pdf-form-templates', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
    );

    if (response?.data) {
      dispatch(setTemplateCreated(true));
    }
  };

export const deletePdfFormTemplate =
  (templateId: number) =>
  async (dispatch: any, _getState = null, utils: any) => {
    const response = await handleApiRequest(
      dispatch,
      utils.Api.delete(`/pdf-form-templates/${templateId}`)
    );

    if (response !== null) {
      dispatch(setTemplateDeleted(true));
    }
  };

export const savePdfFormFields =
  (templateId: number, fields: any[]) =>
  async (dispatch: any, _getState = null, utils: any) => {
    const response = await handleApiRequest(
      dispatch,
      utils.Api.post(`/pdf-form-templates/${templateId}/fields`, { fields })
    );

    if (response !== null) {
      // Auto-update has_signature based on whether the template needs a captured signature/initials mark
      const hasSignature = fields.some((f) => f.field_type === 'signature' || f.field_type === 'initial');
      await handleApiRequest(
        dispatch,
        utils.Api.put(`/pdf-form-templates/${templateId}`, { has_signature: hasSignature })
      );

      dispatch(setFieldsSaved(true));
      return true;
    }

    return false;
  };

/*
 * SUBMISSION API THUNKS
 */

export const listPdfFormSubmissions =
  (page = 1, projectId?: number, companyId?: number | string) =>
  async (dispatch: any, _getState = null, utils: any) => {
    dispatch({ type: FETCHING_PDF_FORM_TEMPLATES, payload: true });

    const params: any = { page };
    if (projectId) params.project_id = projectId;
    // Backend resolves company_id to the active company (ResolveActiveCompany) and scopes the list.
    if (companyId) params.company_id = companyId;

    const response = await handleApiRequest(
      dispatch,
      utils.Api.get('/pdf-form-submissions', { params })
    );

    if (response?.data) {
      dispatch({ type: SET_PDF_FORM_SUBMISSIONS, payload: response });
    }

    dispatch({ type: FETCHING_PDF_FORM_TEMPLATES, payload: false });
  };

export const getPdfFormSubmission =
  (submissionId: number) =>
  async (dispatch: any, _getState = null, utils: any) => {
    const response = await handleApiRequest(
      dispatch,
      utils.Api.get(`/pdf-form-submissions/${submissionId}`)
    );

    if (response?.data) {
      dispatch({ type: SET_PDF_FORM_SUBMISSION, payload: response.data });
    }
  };

export const createPdfFormSubmission =
  (data: {
    pdf_form_template_id: number;
    project_id: number;
    client_name: string;
    client_email: string;
    client_phone?: string;
    field_values?: Record<string, string | number | boolean>;
  }) =>
  async (dispatch: any, _getState = null, utils: any) => {
    const response = await handleApiRequest(
      dispatch,
      utils.Api.post('/pdf-form-submissions', data)
    );

    if (response?.data) {
      dispatch({ type: SET_PDF_FORM_SUBMISSION, payload: response.data });
      dispatch(setSubmissionCreated(true));
      return response.data;
    }
    return null;
  };

export const emailPdfFormSubmission =
  (submissionId: number, email: string) =>
  async (dispatch: any, _getState = null, utils: any) => {
    const response = await handleApiRequest(
      dispatch,
      utils.Api.post(`/pdf-form-submissions/${submissionId}/shares`, { email })
    );

    if (response !== null) {
      dispatch(setSubmissionEmailed(true));
    }
  };

export const sharePdfFormSubmission =
  (submissionId: number, data: { email?: string; phone?: string }) =>
  async (dispatch: any, _getState = null, utils: any) => {
    const response = await handleApiRequest(
      dispatch,
      utils.Api.post(`/pdf-form-submissions/${submissionId}/shares`, data)
    );

    if (response !== null) {
      dispatch(setSubmissionEmailed(true));
      return response;
    }
    return null;
  };

export const fetchProjectClaims =
  (projectId: number) =>
  async (_dispatch: any, _getState = null, utils: any) => {
    try {
      const response = await utils.Api.get(`/projects/${projectId}/claims`);
      return response?.data?.data || [];
    } catch {
      return [];
    }
  };

export const fetchPdfFormTokens =
  () =>
  async (_dispatch: any, _getState = null, utils: any) => {
    try {
      const response = await utils.Api.get('/pdf-form-tokens');
      return response?.data?.data || [];
    } catch {
      return [];
    }
  };

export const deletePdfFormSubmission =
  (submissionId: number) =>
  async (dispatch: any, _getState = null, utils: any) => {
    const response = await handleApiRequest(
      dispatch,
      utils.Api.delete(`/pdf-form-submissions/${submissionId}`)
    );

    if (response !== null) {
      dispatch(setSubmissionDeleted(true));
    }
  };
